var mentions_default = {
  "mentionPalette": "agjrs",
  "mention": "tMAVl",
  "mentionViewer": "m0f-N",
  "mentionSuggestionsEntry": "_9D5cI",
  "mentionSuggestionsEntryFocused": "GjSrY",
  "mentionSuggestionsEntryText": "sbXqs",
  "mentionSuggestionsEntryAvatar": "vXPKE",
  "mentionSuggestions": "dBpa6",
  "cursorDefault": "xQwjI",
  "cursorPointer": "DXqVk"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
